import * as React from "react";
import styled from "styled-components";
import Drawer from "components/common/Drawer";
const StyledDrawer = styled(Drawer)`
  .mantine-Drawer-body {
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
`;
const AddWidgetDrawer = ({ children = void 0, onClose }) => /* @__PURE__ */ React.createElement(StyledDrawer, { onClose, position: "right", size: "66%", title: "Add Widgets", closeOnClickOutside: false }, children);
export default AddWidgetDrawer;
